var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keypress',{attrs:{"key-event":"keyup","preventDefault":true,"multiple-keys":_vm.multiple},on:{"any":_vm.onKeyup,"success":_vm.multipleKeys}})}
var staticRenderFns = []

export { render, staticRenderFns }